import NextImage from '@/features/Image';
import Link from 'next/link';

const BlogCard = ({
  item,
  className = 'col-lg-4 col-md-6',
}: {
  item: any;
  className?: string;
}) => {
  return (
    <div className={className}>
      <div className="blog__item">
        <div className="blog__item-inner">
          <div className="blog__thumb">
            <NextImage
              width={401}
              height={266}
              src={item?.picture[0]?.url}
              alt="blog Images"
            />
          </div>
          <div className="blog__content  blog__content--style2">
            {item?.blog_categories?.length > 0 && (
              <div className="blog__meta">
                <Link href="/blogs">
                  {item?.blog_categories?.map((item: any, i: number) => (
                    <span
                      key={item?.id || i}
                      className={`blog__meta-tag blog__meta-tag--style2`}
                    >
                      {item?.name}
                    </span>
                  ))}
                </Link>
              </div>
            )}
            {/* 
            {item.hashtags && (
              <div className="blog__meta">
                <Link href="/blogs">
                  <span className={`blog__meta-tag blog__meta-tag--style2`}>
                    {item?.hashtags.split(',')[0].trim()}
                  </span>
                </Link>
              </div>
            )} */}
            <h6 className="fw-semibold">
              <Link href={`/blog/${item?.slug}` || ''}>{item?.title}</Link>
            </h6>
            {/* <div className="blog__admin">
              <div className="blog__admin-name">
                <span>
                  <FaRegUser />
                </span>{' '}
                <span>{item?.author}</span>
              </div>
              <div className="blog__admin-date">
                <span>
                  <LuCalendar1 />
                </span>{' '}
                <span>{item?.created_at}</span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
